import React from 'react';

import clsx from 'classnames';

import { UiTextAlign, UiTextTag, UiTextVariant, UiTextWeight } from '@shared/ui/UiText/index.type';

import styles from './UiText.module.css';

interface UiTextProps extends React.HTMLAttributes<HTMLElement> {
    tag?: UiTextTag;
    variant?: UiTextVariant;
    weight?: UiTextWeight;
    align?: UiTextAlign;
    classes?: string;
    children: React.ReactNode;
}

export const UiText = React.forwardRef<HTMLElement, UiTextProps>(
    (
        {
            tag: Tag = 'p',
            variant = 'plain',
            weight = 'regular',
            color = 'inherit',
            align = 'left',
            classes,
            className,
            children,
            ...rest
        },
        ref
    ) => (
        <Tag
            // типизация намеренно слетает, не стал запариваться с дженериками, в этом кейсе это избыточно
            ref={ref}
            className={clsx(
                styles.uiText,
                styles[variant],
                styles[weight],
                styles[color],
                styles[align],
                classes,
                className
            )}
            {...rest}
        >
            {children}
        </Tag>
    )
);

UiText.displayName = 'UiText';

// export const UiText: React.FC<UiTextProps> = ({
//     tag: Tag = 'p',
//     variant = 'plain',
//     weight = 'regular',
//     color = 'inherit',
//     align = 'left',
//     classes,
//     className,
//     children,
//     ...rest
// }) => (
//     <Tag
//         className={clsx(
//             styles.uiText,
//             styles[variant],
//             styles[weight],
//             styles[color],
//             styles[align],
//             classes,
//             className
//         )}
//         {...rest}
//     >
//         {children}
//     </Tag>
// );
